import {
    FAVORITELISTS_RECEIVE_DATA,
    FAVORITELISTS_RECEIVE_IDS,
    FAVORITELISTS_ADDED_ITEM,
    FAVORITELISTS_REMOVED_ITEM,
} from '../Actions/FavoriteLists.action';

const defaultState = {
    favoriteListData: null, // full FavoriteList or null
    favoriteListIds: [], // array of variantIds
    favoriteListIdsLoaded: false, // boolean to indicate if the favorite list IDs have been loaded, dont know if we should have a dirty-state, or reload more often?
};

export const favoriteLists = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case FAVORITELISTS_RECEIVE_DATA: {
            const list = payload.data; // full FavoriteList
            // const ids = list?.items?.map((i) => i.itemNo) ?? []; // Check if this works, was variantId before, but should work now with itemNo
            return {
                ...state,
                favoriteListData: list,
                // favoriteListIds: ids,
            };
        }

        case FAVORITELISTS_RECEIVE_IDS: {
            return { ...state, favoriteListIds: payload.ids, favoriteListIdsLoaded: true };
        }

        case FAVORITELISTS_ADDED_ITEM: {
            const id = payload.variantId;
            if (state.favoriteListIds.includes(id)) return state;
            return {
                ...state,
                favoriteListIds: [...state.favoriteListIds, id],
            };
        }

        case FAVORITELISTS_REMOVED_ITEM: {
            const id = payload.variantId;
            return {
                ...state,
                favoriteListIds: state.favoriteListIds.filter((x) => x !== id),
            };
        }

        default:
            return state;
    }
};
